import { Component, inject, OnInit } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { finalize } from 'rxjs';

// Package.json
import packageJson from '../../../../../package.json';

// Theming
import { faAt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// Services
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../../shared/services/toast.service';
import { RecaptchaService } from '../../services/recaptcha.service';

// Components
import { OtpComponent } from "../otp/otp.component";
import { LoadingButtonComponent } from "../../../shared/components/loading-button/loading-button.component";
import { ChangePasswordComponent } from "../change-password/change-password.component";
import { PasswordInputComponent } from "../../../shared/components/password-input/password-input.component";


@Component({
  selector: 'app-login',
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    LoadingButtonComponent,
    OtpComponent,
    ChangePasswordComponent,
    PasswordInputComponent
],
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  public version: string = packageJson.version;
  private readonly router = inject(Router);
  private readonly fb = inject(FormBuilder);
  private readonly authSrv = inject(AuthService);
  private readonly toastSrv = inject(ToastService);
  private readonly recaptcha = inject(RecaptchaService);

  loginForm = this.fb.nonNullable.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  loading = false;

  faAt = faAt;

  otpexpireIn!: number;

  nextStep!: string | null;

  ngOnInit(): void {
    const token = this.authSrv.getAccessToken();
    if (token) {
      this.authSrv.clearSession();
    }
  }

  loginWithOTP() {
    if (this.loginForm.valid) {
      this.loading = true;

      // Execute reCAPTCHA action
      const recaptchaAction = 'auth_login'
      this.recaptcha.executeAction(recaptchaAction).then(recaptchaToken => {
        console.debug('reCAPTCHA token:', recaptchaToken);

        const formValue = this.loginForm.getRawValue();

        this.authSrv.loginWithOTP(formValue.username, formValue.password, recaptchaAction, recaptchaToken)
          .pipe(finalize(() => this.loading = false))
          .subscribe(
            {
              next: (res) => {
                console.debug('OTP Next Step: ', res.nextStep);
                this.nextStep = res.nextStep;
                this.otpexpireIn = res.expiresInSeconds;
                this.toastSrv.show({ type: 'success', message: res.message });
              }
            });
      }).catch(error => {
        console.error('Errore reCAPTCHA:', error);
      });
    }
  }

  finalizeLogin() {
    if (this.nextStep !== 'CHANGE_PASSWORD') {
      this.completeLogin();
    } else {
      this.nextStep = 'OTP_CHANGE_PASSWORD';
    }
  }

  private completeLogin() {
    this.loading = true;
    this.authSrv.finalizeLoginWithOtp()
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        {
          next: () => {
            console.debug('Logged In!');
            this.router.navigate(['/']);
          }
        });
  }
}
